import GUI from "lil-gui";
import { PointName } from "@/data/content";

const debuggingControlsMixin = {
  data() {
    return {
      totalStation: {}
    };
  },
  methods: {
    createFolder(gui, key) {
      // If default params don't exist, or debug controls are not active, don't create the folder
      if (!this.envParams[key]?.debugControlsActive) {
        return;
      }

      let envFolder = gui.addFolder("Environment Parameters " + key);
      envFolder.add(this.envParams[key], "radius", 100, 2000).onChange(() => {
        if (this.environmentMap) {
          this.environmentMap.radius = this.envParams[key].radius;
        }
      });

      envFolder.add(this.envParams[key], "height", 0, 50).onChange(() => {
        if (this.environmentMap) {
          this.environmentMap.height = this.envParams[key].height;
        }
      });

      envFolder
        .add(this.envParams[key], "rotation", -Math.PI, Math.PI)
        .onChange(() => {
          if (this.environmentMap) {
            this.environmentMap.mapRotation = this.envParams[key].rotation;
          }
        });

      envFolder
        .add(this.envParams[key], "brightness", 0, 2)
        .name("Brightness")
        .onChange(() => {
          if (this.environmentMap) {
            this.environmentMap.intensity = this.envParams[key].brightness;
          }
        });
    },
    // debugging UI for tweaking environment map parameters
    initGUI() {
      const gui = new GUI();
      this.createFolder(gui, PointName.PI);
      this.createFolder(gui, PointName.TS);
      this.createFolder(gui, PointName.SC);
      this.createFolder(gui, PointName.ST);
    }
  }
};

export default debuggingControlsMixin;
